import { Injectable } from '@angular/core';
import { CartItem } from '../interfaces/cart-item';
import { Attributo } from '../interfaces/custom/attributi';
import { CartService } from './cart.service';

@Injectable({
  providedIn: 'root'
})
export class GiacenzaControlService {

  constructor(private cart : CartService) {

  }

  hasQuantityError(item : CartItem, typeOfQuantity: 'current' | 'cart', qtaControl, qtaItem) {
    let attributeHaveErrors = false;
    if (item.attributi && item.attributi.length) {
        attributeHaveErrors = this.getAttributeErrors(item, typeOfQuantity, qtaControl, qtaItem);
    }

    if (item.product.tipo_articolo == 5 || item.product.tipo_articolo == 6) {
        if (!item.product.flg_esplosione) {
            let box_levels = item.box_levels;
            if (box_levels && box_levels.length) {
                let errors = this.getBoxErrors(item, typeOfQuantity, qtaControl, qtaItem);
                if (Object.keys(errors).length)
                    return 'Alcuni articoli nel box non sono disponibili';
                return false;
            }
        }
    }

    if (attributeHaveErrors)
        return 'Alcuni attributi non sono disponibili';

    let willRemain = this.willRemainQuantity(item, typeOfQuantity, qtaControl, qtaItem);
    let conf = item.product.conf_active;
    let div_pz = 1;
    let remain = Math.floor(willRemain.willRemain / div_pz);
    if (remain >= 0)
        return false;
    let giacenza = Math.floor(willRemain.giacenza / div_pz);
    if (giacenza >= 1)
        return `Quantità disponibile (${giacenza}) superata`;
    return 'Articolo esaurito';
  }

  getAttributeErrors(item: CartItem, typeOfQuantity, qtaControl, qtaItem) {
    let haveError = false;

    let getQtyInBox = (codart) => {
        let count = 0;

        let levels = item.box_levels;
        let attributes = item.attributi;
    
        if (levels) {
          levels.forEach(level => {
            level.items.forEach(it => {
              if (it.codice_articolo_componente == codart)
                count += it.qta_selezionata;
            })
          });
        }
    
        if (attributes) {
          let attrCount = 0;
          attributes.forEach(attribute => {
            if (attribute.tipo_battuta == 0 && attribute.selected && attribute.articolo_collegato == codart && attribute.articolo)
              attrCount += 1;
          });
    
          count += attrCount;
        }
    
        return count;
    }

    let isAttrHaveError = (attr : Attributo) => {
        if (attr.tipo_battuta != 0)
            return false;
    
        if (!attr.articolo)
            return true;

        if (attr.articolo.acquisti_giacenza_negativa)
            return false;

        const _giacenza = attr.articolo.disponibilita_prodotto;
        const _inCart = this.cart.getQuantityOfItemInCart(attr.articolo);
        const _inBox = getQtyInBox(attr.codice_articolo);
        const _curDiff = (qtaControl - qtaItem) * _inBox;

        const qta_considerata = (typeOfQuantity == 'current' ? _inCart + _curDiff : _inCart);

        let willRemain = _giacenza - qta_considerata;
        let giacenza = _giacenza - _inCart + qtaItem * _inBox;

        if (willRemain >= 0)
            return false;

        return true;
    }

    for (let attr of item.attributi) {
        attr.error = isAttrHaveError(attr);
        haveError = attr.error || haveError;
    }

    return haveError;
  }

  getBoxErrors(item: CartItem, typeOfQuantity: 'current' | 'cart', qtaControl, qtaItem) {
    let errors = {};
    let box_levels = item.box_levels;

    let getQtyInBox = (item, box_levels) => {
        let count = 0;
        for (let level of box_levels) {
            for (let subItem of level.items) {
                if (subItem.articolo_componente.codart == item.articolo_componente.codart)
                    count += subItem.qta_selezionata;
            }
        }
            
        return count;
    }

    for (let level of box_levels) {
        for (let subItem of level.items) {
            if (subItem.articolo_componente.acquisti_giacenza_negativa)
                continue;

            const _giacenza = subItem.articolo_componente.disponibilita_prodotto;
            const _inCart = this.cart.getQuantityOfItemInCart(subItem.articolo_componente);
            const _inBox = getQtyInBox(subItem, box_levels);
            const _curDiff = (qtaControl - qtaItem) * _inBox;

            const qta_considerata = (typeOfQuantity == 'current' ? _inCart + _curDiff : _inCart);

            let willRemain = _giacenza - qta_considerata;
            let giacenza = _giacenza - _inCart + qtaItem * _inBox;

            if (willRemain >= 0)
                continue;
            
            errors[subItem.articolo_componente.codart] = true;
        }
    }

    return errors;
  }

  willRemainQuantity(item: CartItem, typeOfQuantity: 'current' | 'cart', qtaControl, qtaItem): {
    willRemain: number,
    giacenza: number
} {
    if (item.product.acquisti_giacenza_negativa)
        return {
            willRemain: Number.POSITIVE_INFINITY,
            giacenza: Number.POSITIVE_INFINITY
        }
    if (!item.options) {
        const _giacenza = item.product.giacenze.giacenza.giacenza;
        const _inCart = this.cart.getQuantityOfItemInCart(item.product);
        const conf = item.product.conf_active;
        const pz = 1;
        const _curDiff = (qtaControl - qtaItem) * pz;
        const qta_considerata = (typeOfQuantity == 'current' ? _inCart + _curDiff : _inCart);
        return {
            willRemain: _giacenza - qta_considerata,
            giacenza: _giacenza - _inCart + qtaItem * pz
        }
    }

    const STR_OPT_LIST = "option_list";
    const STR_OPT_CODE = "option_code";
    let giacenzaToFound = {};

    let options = item.options;
    for (let i = 1; i <= 4; i++) {
        giacenzaToFound[STR_OPT_LIST + i] = 0;
        giacenzaToFound[STR_OPT_CODE + i] = 0;
        if (options[i] && options[i].list.indmagazzino) {
            giacenzaToFound[STR_OPT_LIST + i] = options[i].list.option_list;
            giacenzaToFound[STR_OPT_CODE + i] = options[i].option.progressivo;
        }
    }

    let isEqual = (a, b) => {
        for (let i = 1; i <= 4; i++) {
            if (a[STR_OPT_LIST + i] != b[STR_OPT_LIST + i] ||
                a[STR_OPT_CODE + i] != b[STR_OPT_CODE + i])
                return false;
        }
        return true;
    }

    let giacenzaObj = item.product.giacenze.giacenza_opt.find(obj => isEqual(obj, giacenzaToFound));

    let cart_quantity;
    if (typeOfQuantity == 'cart')
        cart_quantity = this.cart.getQuantityOfItemWithOptions(item.product);
    else
        cart_quantity = this.getRequiredQuantityOfItemWithOptions(item);
    let cartQuantityObj = cart_quantity.find(obj => isEqual(obj, giacenzaToFound));

    let diff = (giacenzaObj ? giacenzaObj.giacenza : 0) - (cartQuantityObj ? cartQuantityObj.giacenza : 0);
    return {
        willRemain: diff,
        giacenza: giacenzaObj ? giacenzaObj.giacenza : 0
    };
  }

  getRequiredQuantityOfItemWithOptions(item: CartItem) {
    let items = this.cart.items.filter(eachItem => {
        return eachItem.product.identificativo_azienda == item.product.identificativo_azienda &&
            eachItem.product.codart == item.product.codart;
    });
    let giacenza_opt = [];
    for (let item of items) {
        let giacenza = {};
        const STR_OPT_LIST = "option_list";
        const STR_OPT_CODE = "option_code";
        for (let i = 1; i <= 4; i++) {
            giacenza[STR_OPT_LIST + i] = 0;
            giacenza[STR_OPT_CODE + i] = 0;
            if (item.options[i] && item.options[i].list.indmagazzino) {
                giacenza[STR_OPT_LIST + i] = item.options[i].list.option_list;
                giacenza[STR_OPT_CODE + i] = item.options[i].option.progressivo;
            }
        }
        let oldGiacenza = giacenza_opt.find(obj => {
            for (let key of Object.keys(giacenza)) {
                if (obj[key] != giacenza[key])
                    return false;
            }
            return true;
        });

        if (oldGiacenza)
            oldGiacenza.giacenza += item.quantity;
        else {
            giacenza['giacenza'] = item.quantity;
            giacenza_opt.push(giacenza);
        }
    }
    return giacenza_opt;
}

}
